(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knot-cms_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-knot-cms-slider').forEach((slider) => {
    if (slider.classList.contains('is-initialized')) return;

    new Splide(slider, {
      type: 'loop',
			focus: 'center',
      perPage: 3,
      perMove: 1,
      gap: '10px',
      padding: {
        left: '80px',
        right: '80px',
      },
      pagination: true,
      arrows: true,
      breakpoints: {
        767: {
          perPage: 1,
        },
      },
    }).mount();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knot-cms_slider2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-knot-cms-slider2').forEach((slider) => {
    if (slider.classList.contains('is-initialized')) return;
    if (!slider.querySelector('.splide__slide')) return;

    new Splide(slider, {
      type: 'loop',
      focus: 'center',
      perPage: 1,
      perMove: 1,
      arrows: true,
      pagination: false,
    }).mount();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mypage-coupon-list"]) return;
  try {
    
  (function () {
    // 中間サーバー（S1で設置・サブディレクトリ配置。environments.md §4.1.1）
    var API_BASE = 'https://knotdesigns.xsrv.jp/coupon';
    var FETCH_TIMEOUT_MS = 8000;

    /* ==================== ここから生成のコア（site / MCP で同一） ==================== */

    /** 誤り訂正レベル（L=約7% / M=約15% / Q=約25% / H=約30%まで復元できる） */
    const QR_EC_LEVELS = ['L', 'M', 'Q', 'H'];
    /** 形式情報に書き込むレベルの2bit表現（数字の大小と並びが一致しないので表で持つ） */
    const QR_EC_BITS = { L: 1, M: 0, Q: 3, H: 2 };
    /** 符号化モード（auto は入力を見て numeric → alnum → byte の順に選ぶ） */
    const QR_MODES = ['auto', 'numeric', 'alnum', 'byte'];
    /** 英数字モードで使える45文字。この並び順がそのまま値（0〜44）になる */
    const QR_ALNUM_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
    /** 1ブロックあたりの誤り訂正コード語数（添字＝型番1〜40。0番は未使用） */
    const QR_ECC_PER_BLOCK = {
      L: [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      M: [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
      Q: [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      H: [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    };
    /** 誤り訂正ブロックの数（添字＝型番1〜40） */
    const QR_BLOCKS = {
      L: [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
      M: [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
      Q: [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
      H: [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81],
    };
    /** マスクのペナルティ点（JIS X 0510 の N1〜N4） */
    const QR_PENALTY = { N1: 3, N2: 3, N3: 40, N4: 10 };

    /** 文字列をUTF-8のバイト列にする（QRの8bitバイトモードはバイト列をそのまま載せる） */
    function qrUtf8Bytes(text) {
      return new TextEncoder().encode(text);
    }

    /** 数字モードで書けるか（0〜9だけか） */
    function qrIsNumeric(text) {
      return text.length > 0 && /^[0-9]+$/.test(text);
    }

    /** 英数字モードで書けるか（45文字の表に全部あるか。小文字は入らない） */
    function qrIsAlnum(text) {
      if (text.length === 0) return false;
      for (const ch of text) {
        if (QR_ALNUM_CHARS.indexOf(ch) === -1) return false;
      }
      return true;
    }

    /** 入力に合う最も密なモードを選ぶ（数字 > 英数字 > バイト の順に容量が良い） */
    function qrPickMode(text) {
      if (qrIsNumeric(text)) return 'numeric';
      if (qrIsAlnum(text)) return 'alnum';
      return 'byte';
    }

    /** 文字数指示子のビット数（型番の帯で変わる） */
    function qrCharCountBits(mode, version) {
      const i = version <= 9 ? 0 : version <= 26 ? 1 : 2;
      if (mode === 'numeric') return [10, 12, 14][i];
      if (mode === 'alnum') return [9, 11, 13][i];
      return [8, 16, 16][i];
    }

    /** 型番ごとの、機能パターンと形式・型番情報を除いたデータ用モジュール数 */
    function qrNumRawDataModules(version) {
      let result = (16 * version + 128) * version + 64;
      if (version >= 2) {
        const numAlign = Math.floor(version / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (version >= 7) result -= 36;
      }
      return result;
    }

    /** 型番・誤り訂正レベルごとに載せられるデータコード語数 */
    function qrNumDataCodewords(version, ecLevel) {
      return (
        Math.floor(qrNumRawDataModules(version) / 8) -
        QR_ECC_PER_BLOCK[ecLevel][version] * QR_BLOCKS[ecLevel][version]
      );
    }

    /** モードと入力の長さから、データ部に必要なビット数を求める */
    function qrSegmentBits(mode, text, bytes, version) {
      const header = 4 + qrCharCountBits(mode, version);
      if (mode === 'numeric') {
        const n = text.length;
        return header + Math.floor(n / 3) * 10 + (n % 3 === 1 ? 4 : n % 3 === 2 ? 7 : 0);
      }
      if (mode === 'alnum') {
        const n = text.length;
        return header + Math.floor(n / 2) * 11 + (n % 2 === 1 ? 6 : 0);
      }
      return header + bytes.length * 8;
    }

    /** ビット列を組み立てる小さな入れ物（1要素＝1bit） */
    function qrBitBuffer() {
      const bits = [];
      return {
        bits,
        push(value, len) {
          for (let i = len - 1; i >= 0; i -= 1) bits.push((value >>> i) & 1);
        },
      };
    }

    /** 選んだモードでデータ部のビット列を書く */
    function qrWriteSegment(bb, mode, text, bytes, version) {
      if (mode === 'numeric') {
        bb.push(0b0001, 4);
        bb.push(text.length, qrCharCountBits(mode, version));
        for (let i = 0; i < text.length; i += 3) {
          const chunk = text.slice(i, i + 3);
          bb.push(parseInt(chunk, 10), chunk.length * 3 + 1);
        }
        return;
      }
      if (mode === 'alnum') {
        bb.push(0b0010, 4);
        bb.push(text.length, qrCharCountBits(mode, version));
        for (let i = 0; i < text.length; i += 2) {
          const a = QR_ALNUM_CHARS.indexOf(text[i]);
          if (i + 1 < text.length) {
            bb.push(a * 45 + QR_ALNUM_CHARS.indexOf(text[i + 1]), 11);
          } else {
            bb.push(a, 6);
          }
        }
        return;
      }
      bb.push(0b0100, 4);
      bb.push(bytes.length, qrCharCountBits(mode, version));
      for (const b of bytes) bb.push(b, 8);
    }

    /** GF(256)（原始多項式 0x11D）の掛け算 */
    function qrGfMul(x, y) {
      let z = 0;
      for (let i = 7; i >= 0; i -= 1) {
        z = (z << 1) ^ ((z >>> 7) * 0x11d);
        z ^= ((y >>> i) & 1) * x;
      }
      return z & 0xff;
    }

    /** 次数degreeのリード・ソロモン生成多項式 */
    function qrRsDivisor(degree) {
      const result = new Uint8Array(degree);
      result[degree - 1] = 1;
      let root = 1;
      for (let i = 0; i < degree; i += 1) {
        for (let j = 0; j < degree; j += 1) {
          result[j] = qrGfMul(result[j], root);
          if (j + 1 < degree) result[j] ^= result[j + 1];
        }
        root = qrGfMul(root, 0x02);
      }
      return result;
    }

    /** データコード語の剰余＝誤り訂正コード語 */
    function qrRsRemainder(data, divisor) {
      const result = new Uint8Array(divisor.length);
      for (const b of data) {
        const factor = b ^ result[0];
        result.copyWithin(0, 1);
        result[result.length - 1] = 0;
        for (let i = 0; i < divisor.length; i += 1) result[i] ^= qrGfMul(divisor[i], factor);
      }
      return result;
    }

    /** データをブロックへ分け、誤り訂正コード語を付けて交互に並べ直す */
    function qrAddEccAndInterleave(data, version, ecLevel) {
      const numBlocks = QR_BLOCKS[ecLevel][version];
      const eccLen = QR_ECC_PER_BLOCK[ecLevel][version];
      const rawCodewords = Math.floor(qrNumRawDataModules(version) / 8);
      const numShortBlocks = numBlocks - (rawCodewords % numBlocks);
      const shortBlockLen = Math.floor(rawCodewords / numBlocks);

      const blocks = [];
      const divisor = qrRsDivisor(eccLen);
      for (let i = 0, k = 0; i < numBlocks; i += 1) {
        const len = shortBlockLen - eccLen + (i < numShortBlocks ? 0 : 1);
        const dat = data.slice(k, k + len);
        k += len;
        const block = Array.from(dat);
        const ecc = qrRsRemainder(dat, divisor);
        if (i < numShortBlocks) block.push(0); // 短いブロックは並べ替えのとき1つ空ける
        for (const b of ecc) block.push(b);
        blocks.push(block);
      }

      const result = new Uint8Array(rawCodewords);
      let p = 0;
      for (let i = 0; i < blocks[0].length; i += 1) {
        for (let j = 0; j < blocks.length; j += 1) {
          // 短いブロックのために空けた1つ（データ部の最後尾）だけ飛ばす
          if (i !== shortBlockLen - eccLen || j >= numShortBlocks) {
            result[p] = blocks[j][i];
            p += 1;
          }
        }
      }
      return result;
    }

    /** 型番から位置合わせパターンの中心座標を求める */
    function qrAlignPositions(version) {
      if (version === 1) return [];
      const numAlign = Math.floor(version / 7) + 2;
      const step = version === 32 ? 26 : Math.ceil((version * 4 + 4) / (numAlign * 2 - 2)) * 2;
      const size = version * 4 + 17;
      const result = [6];
      for (let pos = size - 7; result.length < numAlign; pos -= step) result.splice(1, 0, pos);
      return result;
    }

    /** すべてのモジュールを白で初期化した作業用の面を作る */
    function qrNewGrid(size) {
      const rows = [];
      for (let y = 0; y < size; y += 1) rows.push(new Uint8Array(size));
      return rows;
    }

    /** 機能パターン（位置検出・分離・タイミング・位置合わせ）を描く */
    function qrDrawFunctionPatterns(modules, isFunction, version) {
      const size = modules.length;
      const set = (x, y, dark) => {
        if (x < 0 || y < 0 || x >= size || y >= size) return;
        modules[y][x] = dark ? 1 : 0;
        isFunction[y][x] = 1;
      };

      // タイミングパターン（6行目・6列目の白黒の交互）
      for (let i = 0; i < size; i += 1) {
        set(6, i, i % 2 === 0);
        set(i, 6, i % 2 === 0);
      }

      // 位置検出パターン3つ（分離パターンの白まで含めて9×9を塗る）
      for (const [cx, cy] of [[3, 3], [size - 4, 3], [3, size - 4]]) {
        for (let dy = -4; dy <= 4; dy += 1) {
          for (let dx = -4; dx <= 4; dx += 1) {
            const dist = Math.max(Math.abs(dx), Math.abs(dy));
            set(cx + dx, cy + dy, dist !== 2 && dist !== 4);
          }
        }
      }

      // 位置合わせパターン（3隅の位置検出パターンと重なる組み合わせは置かない）
      const pos = qrAlignPositions(version);
      const last = pos.length - 1;
      for (let i = 0; i <= last; i += 1) {
        for (let j = 0; j <= last; j += 1) {
          if ((i === 0 && j === 0) || (i === 0 && j === last) || (i === last && j === 0)) continue;
          for (let dy = -2; dy <= 2; dy += 1) {
            for (let dx = -2; dx <= 2; dx += 1) {
              set(pos[i] + dx, pos[j] + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
            }
          }
        }
      }

      // 形式情報の領域を機能パターンとして押さえる（中身はマスク確定後に書く）
      qrDrawFormatBits(modules, isFunction, 'M', 0);
      qrDrawVersionBits(modules, isFunction, version);
    }

    /** 形式情報15bit（誤り訂正レベル＋マスク番号＋BCH符号）を2か所へ書く */
    function qrDrawFormatBits(modules, isFunction, ecLevel, mask) {
      const size = modules.length;
      const set = (x, y, dark) => {
        modules[y][x] = dark ? 1 : 0;
        isFunction[y][x] = 1;
      };
      const data = (QR_EC_BITS[ecLevel] << 3) | mask;
      let rem = data;
      for (let i = 0; i < 10; i += 1) rem = (rem << 1) ^ ((rem >>> 9) * 0x537);
      const bits = ((data << 10) | rem) ^ 0x5412;
      const bit = (i) => ((bits >>> i) & 1) === 1;

      for (let i = 0; i <= 5; i += 1) set(8, i, bit(i));
      set(8, 7, bit(6));
      set(8, 8, bit(7));
      set(7, 8, bit(8));
      for (let i = 9; i < 15; i += 1) set(14 - i, 8, bit(i));

      for (let i = 0; i < 8; i += 1) set(size - 1 - i, 8, bit(i));
      for (let i = 8; i < 15; i += 1) set(8, size - 15 + i, bit(i));
      set(8, size - 8, true); // 常に黒のモジュール
    }

    /** 型番情報18bit（型番7以上のみ）を左下と右上へ書く */
    function qrDrawVersionBits(modules, isFunction, version) {
      if (version < 7) return;
      const size = modules.length;
      let rem = version;
      for (let i = 0; i < 12; i += 1) rem = (rem << 1) ^ ((rem >>> 11) * 0x1f25);
      const bits = (version << 12) | rem;
      for (let i = 0; i < 18; i += 1) {
        const dark = ((bits >>> i) & 1) === 1;
        const a = size - 11 + (i % 3);
        const b = Math.floor(i / 3);
        modules[b][a] = dark ? 1 : 0;
        isFunction[b][a] = 1;
        modules[a][b] = dark ? 1 : 0;
        isFunction[a][b] = 1;
      }
    }

    /** コード語を右下から2列ずつ、上下に折り返しながら置く */
    function qrDrawCodewords(modules, isFunction, data) {
      const size = modules.length;
      let i = 0;
      for (let right = size - 1; right >= 1; right -= 2) {
        if (right === 6) right = 5; // タイミングパターンの列は飛ばす
        for (let vert = 0; vert < size; vert += 1) {
          for (let j = 0; j < 2; j += 1) {
            const x = right - j;
            const upward = ((right + 1) & 2) === 0;
            const y = upward ? size - 1 - vert : vert;
            if (!isFunction[y][x] && i < data.length * 8) {
              modules[y][x] = (data[i >>> 3] >>> (7 - (i & 7))) & 1;
              i += 1;
            }
          }
        }
      }
    }

    /** マスクを掛ける（同じ関数をもう一度呼べば外れる） */
    function qrApplyMask(modules, isFunction, mask) {
      const size = modules.length;
      for (let y = 0; y < size; y += 1) {
        for (let x = 0; x < size; x += 1) {
          if (isFunction[y][x]) continue;
          let invert = false;
          switch (mask) {
            case 0: invert = (x + y) % 2 === 0; break;
            case 1: invert = y % 2 === 0; break;
            case 2: invert = x % 3 === 0; break;
            case 3: invert = (x + y) % 3 === 0; break;
            case 4: invert = (Math.floor(y / 2) + Math.floor(x / 3)) % 2 === 0; break;
            case 5: invert = ((x * y) % 2) + ((x * y) % 3) === 0; break;
            case 6: invert = (((x * y) % 2) + ((x * y) % 3)) % 2 === 0; break;
            default: invert = (((x + y) % 2) + ((x * y) % 3)) % 2 === 0; break;
          }
          if (invert) modules[y][x] ^= 1;
        }
      }
    }

    /** 読み取りにくい並びへの減点（小さいほど読みやすい） */
    function qrPenaltyScore(modules) {
      const size = modules.length;
      let result = 0;

      // N1: 同じ色が5つ以上続く並び（縦・横）
      const runScore = (len) => (len >= 5 ? QR_PENALTY.N1 + (len - 5) : 0);
      for (let y = 0; y < size; y += 1) {
        let runColor = modules[y][0];
        let runLen = 1;
        for (let x = 1; x < size; x += 1) {
          if (modules[y][x] === runColor) {
            runLen += 1;
          } else {
            result += runScore(runLen);
            runColor = modules[y][x];
            runLen = 1;
          }
        }
        result += runScore(runLen);
      }
      for (let x = 0; x < size; x += 1) {
        let runColor = modules[0][x];
        let runLen = 1;
        for (let y = 1; y < size; y += 1) {
          if (modules[y][x] === runColor) {
            runLen += 1;
          } else {
            result += runScore(runLen);
            runColor = modules[y][x];
            runLen = 1;
          }
        }
        result += runScore(runLen);
      }

      // N2: 同じ色の2×2のかたまり
      for (let y = 0; y < size - 1; y += 1) {
        for (let x = 0; x < size - 1; x += 1) {
          const c = modules[y][x];
          if (c === modules[y][x + 1] && c === modules[y + 1][x] && c === modules[y + 1][x + 1]) {
            result += QR_PENALTY.N2;
          }
        }
      }

      // N3: 位置検出パターンに似た並び（1011101 の前後どちらかに白4つ）
      const finderLike = (get, n) => {
        let count = 0;
        for (let i = 0; i + 6 < n; i += 1) {
          const p = [];
          for (let k = 0; k < 7; k += 1) p.push(get(i + k));
          if (!(p[0] && !p[1] && p[2] && p[3] && p[4] && !p[5] && p[6])) continue;
          let before = true;
          for (let k = i - 4; k < i; k += 1) if (k >= 0 && get(k)) before = false;
          let after = true;
          for (let k = i + 7; k < i + 11; k += 1) if (k < n && get(k)) after = false;
          if (before || after) count += 1;
        }
        return count;
      };
      for (let y = 0; y < size; y += 1) result += QR_PENALTY.N3 * finderLike((x) => modules[y][x] === 1, size);
      for (let x = 0; x < size; x += 1) result += QR_PENALTY.N3 * finderLike((y) => modules[y][x] === 1, size);

      // N4: 黒の比率が50%からどれだけ離れているか（5%ごとに加点）
      let dark = 0;
      for (let y = 0; y < size; y += 1) {
        for (let x = 0; x < size; x += 1) dark += modules[y][x];
      }
      const total = size * size;
      const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      result += Math.max(k, 0) * QR_PENALTY.N4;
      return result;
    }

    /**
     * 文字列をQRコードのモジュール配列にする。
     *
     * opts:
     *   ecLevel  'L' | 'M' | 'Q' | 'H'（既定 'M'）
     *   mode     'auto' | 'numeric' | 'alnum' | 'byte'（既定 'auto'）
     *   minVersion / maxVersion  型番の下限・上限（1〜40。既定 1〜40）
     *   mask     0〜7を指定すると固定。省略時はペナルティの一番低いものを選ぶ
     *
     * 返り値の modules は [y][x] の Uint8Array（1＝黒）。
     */
    function qrEncode(text, opts) {
      const o = opts || {};
      const src = typeof text === 'string' ? text : String(text == null ? '' : text);
      if (src.length === 0) throw new RangeError('empty input');
      const ecLevel = QR_EC_LEVELS.indexOf(o.ecLevel) === -1 ? 'M' : o.ecLevel;
      const minVersion = Math.min(Math.max(Math.trunc(o.minVersion || 1), 1), 40);
      const maxVersion = Math.min(Math.max(Math.trunc(o.maxVersion || 40), minVersion), 40);

      const wanted = QR_MODES.indexOf(o.mode) === -1 ? 'auto' : o.mode;
      const auto = qrPickMode(src);
      let mode = wanted === 'auto' ? auto : wanted;
      if (mode === 'numeric' && !qrIsNumeric(src)) mode = auto;
      if (mode === 'alnum' && !qrIsAlnum(src)) mode = auto;
      const bytes = qrUtf8Bytes(src);

      // 入りきる最小の型番を探す（文字数指示子のビット数が型番の帯で変わるので都度数え直す）
      let version = -1;
      let dataBits = 0;
      let capacityBits = 0;
      for (let v = minVersion; v <= maxVersion; v += 1) {
        const need = qrSegmentBits(mode, src, bytes, v);
        const room = qrNumDataCodewords(v, ecLevel) * 8;
        if (need <= room) {
          version = v;
          dataBits = need;
          capacityBits = room;
          break;
        }
      }
      if (version === -1) throw new RangeError('data too long');

      const bb = qrBitBuffer();
      qrWriteSegment(bb, mode, src, bytes, version);
      // 終端パターン（最大4bitの0）→ バイト境界まで0 → 埋め草を交互に
      for (let i = 0; i < 4 && bb.bits.length < capacityBits; i += 1) bb.bits.push(0);
      while (bb.bits.length % 8 !== 0) bb.bits.push(0);
      for (let pad = 0xec; bb.bits.length < capacityBits; pad ^= 0xec ^ 0x11) bb.push(pad, 8);

      const dataCodewords = new Uint8Array(bb.bits.length / 8);
      for (let i = 0; i < bb.bits.length; i += 1) {
        dataCodewords[i >>> 3] |= bb.bits[i] << (7 - (i & 7));
      }

      const size = version * 4 + 17;
      const modules = qrNewGrid(size);
      const isFunction = qrNewGrid(size);
      qrDrawFunctionPatterns(modules, isFunction, version);
      qrDrawCodewords(modules, isFunction, qrAddEccAndInterleave(dataCodewords, version, ecLevel));

      let mask = Number.isInteger(o.mask) && o.mask >= 0 && o.mask <= 7 ? o.mask : -1;
      if (mask === -1) {
        let best = Infinity;
        for (let m = 0; m < 8; m += 1) {
          qrApplyMask(modules, isFunction, m);
          qrDrawFormatBits(modules, isFunction, ecLevel, m);
          const score = qrPenaltyScore(modules);
          if (score < best) {
            best = score;
            mask = m;
          }
          qrApplyMask(modules, isFunction, m); // 同じマスクをもう一度掛けて元へ戻す
        }
      }
      qrApplyMask(modules, isFunction, mask);
      qrDrawFormatBits(modules, isFunction, ecLevel, mask);

      return {
        modules,
        size,
        version,
        ecLevel,
        mask,
        mode,
        dataBits,
        capacityBits,
        dataCodewords: dataCodewords.length,
        eccCodewords: QR_ECC_PER_BLOCK[ecLevel][version] * QR_BLOCKS[ecLevel][version],
        blocks: QR_BLOCKS[ecLevel][version],
        byteLength: bytes.length,
        charLength: src.length,
      };
    }

    /** 黒モジュールを横に連結した矩形の並びにする（SVG・Canvasで共通に使う） */
    function qrDarkRuns(modules) {
      const runs = [];
      const size = modules.length;
      for (let y = 0; y < size; y += 1) {
        let x = 0;
        while (x < size) {
          if (!modules[y][x]) {
            x += 1;
            continue;
          }
          let w = 1;
          while (x + w < size && modules[y][x + w]) w += 1;
          runs.push([x, y, w]);
          x += w;
        }
      }
      return runs;
    }

    /**
     * モジュール配列をSVGの文字列にする。
     *
     * opts:
     *   size    出力の一辺（px。既定 320）
     *   margin  余白のモジュール数（クワイエットゾーン。既定 4）
     *   dark / light  前景色・背景色（light に 'none' を渡すと背景を描かない）
     */
    function qrMatrixToSvg(qr, opts) {
      const o = opts || {};
      const margin = Math.max(0, Math.trunc(o.margin == null ? 4 : o.margin));
      const px = Math.max(16, Math.trunc(o.size == null ? 320 : o.size));
      const dark = o.dark || '#000000';
      const light = o.light == null ? '#ffffff' : o.light;
      const span = qr.size + margin * 2;

      let d = '';
      for (const [x, y, w] of qrDarkRuns(qr.modules)) {
        d += `M${x + margin} ${y + margin}h${w}v1h-${w}z`;
      }
      const bg = light === 'none' || light === '' ? '' : `<rect width="${span}" height="${span}" fill="${light}"/>`;
      return (
        `<svg xmlns="http://www.w3.org/2000/svg" width="${px}" height="${px}" viewBox="0 0 ${span} ${span}" ` +
        `shape-rendering="crispEdges" role="img" aria-label="QR code">` +
        bg +
        `<path fill="${dark}" d="${d}"/>` +
        `</svg>`
      );
    }

    /* ==================== ここまで生成のコア ==================== */

    // 店頭提示用QRのSVGを作る。生成できない値（空・長すぎる）のときは空文字を返す
    function buildQrSvg(payload) {
      try {
        return qrMatrixToSvg(qrEncode(String(payload), { ecLevel: 'M' }), { size: 240, margin: 4 });
      } catch (e) {
        return '';
      }
    }

    // MypageController の第2経路（会員別トークン）で認証する。
    // トークンが無い＝クーポンをまだ一度も受け取っていない会員なので、
    // 通信せず「クーポンなし」表示に倒す（安全側。401を明示エラー扱いにしない）。
    function getCoupons(token) {
      if (!token) return Promise.resolve([]);

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS) : null;

      return fetch(API_BASE + '/mypage/coupons', {
        headers: { 'X-mypage-token': token },
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          // 401（未認証）・404（会員連携未完了）はいずれも「クーポンなし」表示に倒す
          // （coupon-data-guide-for-coder.md §5 の設計方針と揃える）
          if (!res.ok) return [];
          return res.json().then(function (body) { return body.coupons || []; });
        })
        .catch(function () {
          // 通信失敗時も表示を出さない（安全側に倒す）
          return [];
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
        });
    }

    // 割引表示の整形（shopify-app/extensions/mypage-coupons/src/format.ts の awardType 判定を踏襲）
    function formatDiscount(coupon) {
      var type = String(coupon.awardType);
      if (type === '1') return coupon.awardValue + '円引き';
      if (type === '2') return coupon.awardValue + '%引き';
      if (type === '3') return '商品プレゼント';
      return '';
    }

    // 有効期限の整形。new Date() でパースせず文字列のままJSTとして扱う（UTC解釈による1日ズレを防止）
    function formatExpiry(endDate) {
      if (!endDate) return '';
      if (endDate === '2099-12-31') return '有効期限 | 無期限';
      var parts = endDate.split('-');
      if (parts.length !== 3) return '';
      return '有効期限 | ' + parts[0] + '年' + parseInt(parts[1], 10) + '月' + parseInt(parts[2], 10) + '日まで';
    }

    function renderCoupon(coupon) {
      var el = document.createElement('div');
      el.className = 'mypage-coupon-card';

      // PC_mypage-coupon（node-id=960-11010）実測の構成: 見出し→罫線→本文（左124px画像枠＋右テキスト）→
      // 罫線→ボタン群。画像枠は実画像を入れず装飾のみとし、店頭QRはボタン押下でモーダル表示する
      // （画像枠自体はクリックできるボタンではない。2026-09-15 CSS実測に基づき再実装）。
      var hasQr = !!coupon.qrPayload;
      var hasEc = !!coupon.ecDiscountCode;

      var html = '';
      html += '<p class="mypage-coupon-card__name"></p>';
      html += '<hr class="mypage-coupon-card__divider">';
      html += '<div class="mypage-coupon-card__body">';
      html += '  <div class="mypage-coupon-card__visual" aria-hidden="true"></div>';
      html += '  <div class="mypage-coupon-card__info">';
      html += '    <p class="mypage-coupon-card__discount">' + formatDiscount(coupon) + '</p>';
      if (coupon.summary) {
        html += '    <p class="mypage-coupon-card__summary"></p>';
      }
      var expiry = formatExpiry(coupon.endDate);
      if (expiry) {
        html += '    <p class="mypage-coupon-card__expiry">' + expiry + '</p>';
      }
      if (hasEc) {
        html += '    <p class="mypage-coupon-card__ec-line">クーポンコード | <code class="mypage-coupon-card__ec-code"></code></p>';
      }
      html += '  </div>';
      html += '</div>';
      // 罫線とボタン群はセットで出す。ボタンが0個になるケース（QR・ECどちらも無い）で
      // 空のactionsと孤立した罫線だけが残らないようにする（2026-09-15 Codexレビュー対応）
      if (hasQr || hasEc) {
        html += '<hr class="mypage-coupon-card__divider">';
        html += '<div class="mypage-coupon-card__actions">';
        if (hasQr) {
          html += '  <button type="button" class="mypage-coupon-card__btn mypage-coupon-card__btn--outline" data-coupon-qr-open>店舗で使用</button>';
        }
        if (hasEc) {
          html += '  <button type="button" class="mypage-coupon-card__btn mypage-coupon-card__btn--solid" data-copy-code="">コードをコピー</button>';
        }
        html += '</div>';
      }

      el.innerHTML = html;

      // テキストは textContent で差し込む（サンプルデータ由来だが、将来API化した際の
      // HTMLインジェクション対策の型をここで揃えておく）
      el.querySelector('.mypage-coupon-card__name').textContent = coupon.couponName;
      if (coupon.summary) {
        el.querySelector('.mypage-coupon-card__summary').textContent = coupon.summary;
      }
      if (hasEc) {
        el.querySelector('.mypage-coupon-card__ec-code').textContent = coupon.ecDiscountCode;
        var ecButton = el.querySelector('.mypage-coupon-card__btn--solid');
        ecButton.setAttribute('data-copy-code', coupon.ecDiscountCode);
        // 複数カードをボタン一覧で移動したとき全部「コードをコピー」と読まれてしまうため、
        // QRボタンと同様にクーポン名込みのaria-labelを付ける（2026-09-15 Codexレビュー対応）
        ecButton.setAttribute('aria-label', coupon.couponName + 'のコードをコピー');
      }

      if (hasQr) {
        // SVGは座標と色だけで組み立てており、クーポン番号の文字列は含まない。
        // モーダルを開くまでDOMへ描画せず、カードには明示的なボタンだけを置く。
        var qrSvg = buildQrSvg(coupon.qrPayload);
        var qrButton = el.querySelector('[data-coupon-qr-open]');
        if (qrSvg && qrButton) {
          qrButton.setAttribute('data-qr-svg', qrSvg);
          el.querySelector('.mypage-coupon-card__visual').innerHTML = qrSvg;
          qrButton.setAttribute('data-coupon-name', coupon.couponName);
          qrButton.setAttribute('data-coupon-serial', coupon.qrPayload);
          // スクリーンリーダーで複数カードを一覧したときに「店舗で使用」だけでは
          // どのクーポンか分からないため、aria-labelにクーポン名を含める
          qrButton.setAttribute('aria-label', coupon.couponName + 'を店舗で使用（スタッフにご提示ください）');
        } else if (qrButton) {
          // qrPayloadはあったがSVG生成に失敗したケース。機能しないボタンを残さず削除する。
          // ECコードも無ければactionsが空になるので、直前の罫線と合わせて丸ごと削除する
          var actions = qrButton.closest('.mypage-coupon-card__actions');
          qrButton.parentNode.removeChild(qrButton);
          if (actions && !hasEc) {
            var divider = actions.previousElementSibling;
            if (divider && divider.classList.contains('mypage-coupon-card__divider')) {
              divider.parentNode.removeChild(divider);
            }
            actions.parentNode.removeChild(actions);
          }
        }
      }

      return el;
    }

    function renderEmpty(container) {
      var el = document.createElement('p');
      el.className = 'mypage-coupon-list__empty';
      el.textContent = 'ご利用いただけるクーポンは現在ございません。';
      container.appendChild(el);
    }

    function init() {
      var root = document.getElementById('mypage-coupon-list');
      var container = document.getElementById('mypage-coupon-items');
      var modal = document.getElementById('mypage-coupon-modal');
      var modalQr = document.getElementById('mypage-coupon-modal-qr');
      var modalTitle = document.getElementById('mypage-coupon-modal-title');
      var modalSerial = document.getElementById('mypage-coupon-modal-serial');
      if (!root || !container || !modal || !modalQr || !modalTitle || !modalSerial) return;
      var token = root.getAttribute('data-mypage-token') || '';

      getCoupons(token).then(function (coupons) {
        if (!coupons || coupons.length === 0) {
          renderEmpty(container);
          return;
        }
        coupons.forEach(function (coupon) {
          container.appendChild(renderCoupon(coupon));
        });
      });

      // dialog非対応ブラウザ（showModal/close未実装）向けのフォールバック。
      // open属性の付け外しだけで、フォーカストラップ・Escキー・inert化はブラウザに委ねる
      // （2026-09-15 Codexレビュー: close()未実装環境でmodal.close()が例外になる経路を解消）
      function openModal() {
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      }
      function closeModal() {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }

      container.addEventListener('click', function (event) {
        var qrButton = event.target.closest('[data-coupon-qr-open]');
        if (qrButton) {
          modalQr.innerHTML = qrButton.getAttribute('data-qr-svg') || '';
          var svg = modalQr.querySelector('svg');
          var serial = qrButton.getAttribute('data-coupon-serial') || '';
          modalTitle.textContent = qrButton.getAttribute('data-coupon-name') || 'クーポン';
          modalSerial.textContent = 'クーポン番号：' + serial;
          if (svg) svg.setAttribute('aria-label', '店頭提示用QRコード（クーポン番号：' + serial + '）');
          openModal();
          return;
        }

        var button = event.target.closest('[data-copy-code]');
        if (!button) return;
        var code = button.getAttribute('data-copy-code');
        if (navigator.clipboard && code) {
          navigator.clipboard.writeText(code);
          button.textContent = 'コピーしました';
          setTimeout(function () {
            button.textContent = 'コードをコピー';
          }, 2000);
        }
      });

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-coupon-modal-close]')) {
          closeModal();
          return;
        }
        if (event.target === modal) {
          var rect = modal.getBoundingClientRect();
          var inside = event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) closeModal();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
